<template>
  <div>
    <DcumentsGroupsFormDlg
      :descriptionDocsDialog="descriptionDocsDialog"
      :openForm="() => openForm()"
      :closeForm="() => closeForm()"
      :saveExpenseGroup="(data) => saveExpenseGroup(data)"
      :editDataExpGrp="formData"
    />
    <SearchDocumentsGroups :searchDcumentsGroups="searchDcumentsGroups" />
    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.type }}</td>
        <td class="text-xs-left">{{ props.item.created_at | moment("DD/MM/YYYY")}}</td>
        <td class="text-xs-center layout">
          <!-- <v-icon small class="mr-2" @click="editItem(props.item, 'viewForm')">remove_red_eye</v-icon> -->
          <v-btn class="mx-0" flat icon @click="openForm(props.item)" v-if="permissions.edit">
            <v-icon small>edit</v-icon>
          </v-btn>

          <v-btn class="mx-0" flat icon @click="confirmDelExpGroup(props.item)" v-if="permissions.remove">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data>
        <p
          class="pt-5"
          style="min-height: 200px;"
        >Preencha o campo acima para listar os grupos de documentos do sitema</p>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import DcumentsGroupsFormDlg from './DcumentsGroupsFormDlg.vue'
import SearchDocumentsGroups from './SearchDocumentsGroups.vue'
export default {
  components: {
    DcumentsGroupsFormDlg,
    SearchDocumentsGroups
  },
  mounted () {
    this.searchDcumentsGroups(null)
  },
  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.standardSystem
    }
  },
  methods: {
    confirmToogleStatusItem (data) {
      let action = data.active ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} o grupo de despesas "${data.name}"?`,
        title: `${
          data.active
            ? 'Desativar grupo de despesas'
            : 'Ativar grupo de despesas'
        }`,
        callback: _ => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },
    toogleStatusItem (data) {
      let obj = {
        url: '/api/defaultExpenseGroup/disable_group/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Status modificado com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.searchDcumentsGroups()
      })
    },
    confirmDelExpGroup (data) {
      let obj = {
        message: `Você deseja excluir o grupo de documentos "${data.type}"?`,
        title: 'Excluir grupo de despesa',
        callback: _ => {
          this.delExpGroup(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },
    delExpGroup (data) {
      let obj = {
        url: '/api/typefile/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Grupo de despesas removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.searchDcumentsGroups()
      })
    },
    saveExpenseGroup (data) {
      //      console.log(data);
      data.name = data.type
      let obj = {
        url: '/api/typefile' + (data.id ? `/${data.id}` : ''),
        query: data,
        method: data.id ? 'patch' : 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        let opts = {
          message: `Grupo de documento salvo com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)

        this.formData = { ...response.data }
        this.searchDcumentsGroups()
      })
    },
    openForm (data) {
      if (data) {
        this.formData = { ...data }
      } else {
        this.formData = {}
      }
      this.descriptionDocsDialog = true
    },
    closeForm () {
      this.descriptionDocsDialog = false
    },
    searchDcumentsGroups (filters) {
      if (!filters) {
        filters = this.lastRequestData
      }
      let dataSearch = {}
      if (filters) {
        dataSearch.params = {
          ...filters
        }
      }
      let obj = {
        url: '/api/typefile',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.tableData = response.data
        this.lastRequestData = filters
      })
    }
  },
  data () {
    return {
      lastRequestData: {},
      formData: {},
      descriptionDocsDialog: false,
      headers: [
        {
          align: 'left',
          text: 'Grupo de documentos',
          sortable: true,
          value: 'type'
        },
        {
          text: 'Data da criação',
          value: 'created_at',
          sortable: true,
          align: 'left'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  }
}
</script>
<style>
</style>
